import { Controller, useFormContext } from 'react-hook-form'
import {
  QuickTimeInterval,
  TimeWindow,
  TimeWindowType,
} from '../../../../shared/models/time.model'
import Select from 'react-select'
import React from 'react'
import { NameBasedProps } from './types'

const QuickTimeIntervalOptions = [
  {
    value: QuickTimeInterval.YESTERDAY,
    label: 'Hier',
    realTime: false,
    history: true,
  },
  {
    value: QuickTimeInterval.DAY_BEFORE_YESTERDAY,
    label: 'Avant-hier',
    realTime: false,
    history: true,
  },
  {
    value: QuickTimeInterval.THIS_DAY_LAST_WEEK,
    label: 'Ce jour la semaine dernière',
    realTime: false,
    history: true,
  },
  {
    value: QuickTimeInterval.PREVIOUS_WEEK,
    label: 'Semaine précédente',
    realTime: false,
    history: true,
  },
  {
    value: QuickTimeInterval.PREVIOUS_WEEK_ISO,
    label: 'Semaine précédente (Lundi - Dimanche)',
    realTime: false,
    history: true,
  },
  {
    value: QuickTimeInterval.PREVIOUS_MONTH,
    label: 'Mois précédent',
    realTime: false,
    history: true,
  },
  {
    value: QuickTimeInterval.PREVIOUS_QUARTER,
    label: 'Trimestre précédent',
    realTime: false,
    history: true,
  },
  {
    value: QuickTimeInterval.PREVIOUS_HALF_YEAR,
    label: 'Semestre précédent',
    realTime: false,
    history: true,
  },
  {
    value: QuickTimeInterval.PREVIOUS_YEAR,
    label: 'Année précédente',
    realTime: false,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_HOUR,
    label: 'Heure courante',
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_DAY,
    label: 'Jour courant',
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_DAY_SO_FAR,
    label: "Jour courant jusqu'à maintenant",
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_WEEK,
    label: 'Semaine courante (Dimanche - Samedi)',
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_WEEK_ISO,
    label: 'Semaine ISO courante (Lundi - Dimanche)',
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_WEEK_SO_FAR,
    label: "Semaine courante jusqu'à maintenant (Dimanche - Samedi)",
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_WEEK_ISO_SO_FAR,
    label: "Semaine ISO courante jusqu'à maintenant (Lundi - Dimanche)",
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_MONTH,
    label: 'Mois courant',
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_MONTH_SO_FAR,
    label: "Mois courant jusqu'à maintenant",
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_QUARTER,
    label: 'Trimestre courant',
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_QUARTER_SO_FAR,
    label: "Trimestre courant jusqu'à maintenant",
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_HALF_YEAR,
    label: 'Semestre courant',
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_HALF_YEAR_SO_FAR,
    label: "Semestre courant jusqu'à maintenant",
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_YEAR,
    label: 'Année courante',
    realTime: true,
    history: true,
  },
  {
    value: QuickTimeInterval.CURRENT_YEAR_SO_FAR,
    label: "Année courante jusqu'à maintenant",
    realTime: true,
    history: true,
  },
]

const QuickIntervalSelector = ({
  name,
  timeWindowsType,
}: NameBasedProps & { timeWindowsType: TimeWindowType }) => {
  const { control } = useFormContext<TimeWindow>()
  const options = QuickTimeIntervalOptions.filter((o) => {
    if (timeWindowsType === TimeWindowType.REAL_TIME) {
      return o.realTime
    } else {
      return o.history
    }
  }).map((o) => ({ value: o.value, label: o.label }))
  return (
    <>
      <Controller
        name={name}
        shouldUnregister={true}
        control={control}
        render={({ field }) => {
          return (
            <Select
              className={'w-100'}
              classNamePrefix={'react-select'}
              options={options}
              onChange={(e) => {
                if (e) {
                  field.onChange(e.value)
                }
              }}
            />
          )
        }}
      />
    </>
  )
}

export default QuickIntervalSelector
